import React, { ReactNode } from 'react';
import { useRouter } from '@uirouter/react';
import { PageTopProps } from './types';

const PageTop = ({ breadcrumb, icon, title }: PageTopProps): JSX.Element => {
    const router = useRouter();

    function handleRouteTo(rt: string): void {
        router.stateService.go(rt);
    }

    function cssTitleIcon(icon: string): string {
        if (typeof icon == 'string') {
            if (icon.startsWith('sprite')) {
                return 'sprite ' + icon;
            } else if (icon.startsWith('icon')) {
                return 'icon-glyph ' + icon;
            }
        }
        return '';
    }

    const bcIcon = breadcrumb && breadcrumb.icon ? 'sprite-link ' + breadcrumb.icon : '';

    return (
        <section className="page-title new-page-top new-page-flex">
            <h4>
                <span
                    className={cssTitleIcon(icon)}
                    aria-hidden="true"
                ></span>
                &nbsp;{title}
                {breadcrumb ? (
                    <Link
                        cssName={'breadcrumb'}
                        onClick={() => handleRouteTo(breadcrumb.route)}
                    >
                        <span
                            className={bcIcon}
                            aria-hidden="true"
                        ></span>
                        &nbsp;{breadcrumb.title}
                    </Link>
                ) : null}
            </h4>
        </section>
    );
};

// HELPERS
type ClickableParams = {
    cssName?: string;
    onClick: () => void;
    children: ReactNode | string | undefined;
};

const Link = ({ cssName, onClick, children }: ClickableParams): JSX.Element => {
    function handleClick(e): void {
        e.preventDefault();
        onClick();
    }
    return (
        <a
            className={cssName}
            onClick={handleClick}
        >
            {children}
        </a>
    );
};

export default PageTop;
